import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { SeoTags } from "./index.js";

import { colorsConfig } from "../config/colorsConfig.js";
import { isoTimestampToLocal } from "./utils/timeStampConversion.js";
import { useUserContext } from "../contexts/UserContextProvider.js";

const ActivityLogs = () => {
  const { apiGetActivityLogs, logsData } = useUserContext();
  const [expandedRows, setExpandedRows] = useState([]);

  const rowPreExpanded = (row) => {
    return (
      <div className="m-3 p-2 grid grid-cols-2 lg:grid-cols-4 gap-1 border border-slate-400 rounded-md">
        <a
          href={`https://maps.google.com/maps?q=${row?.data?.loginRegionDetails?.latitude},${row?.data?.loginRegionDetails?.longitude}&hl=en`}
          target="_blank"
          rel="noopener noreferrer"
          className="my-hover-effect text-wabmBlue text-sm"
        >
          Open Map Location
        </a>
        <p className="text-sm">
          IP Address : {row?.data?.loginRegionDetails?.ipAddress}
        </p>
        <p className="text-sm">
          Latitude : {row?.data?.loginRegionDetails?.latitude}
        </p>
        <p className="text-sm">
          Longitude : {row?.data?.loginRegionDetails?.longitude}
        </p>
        <p className="text-sm">
          Location :{" "}
          {row?.data?.loginRegionDetails?.regionName +
            " " +
            row?.data?.loginRegionDetails?.cityName +
            " " +
            row?.data?.loginRegionDetails?.countryName}
        </p>
        <p className="text-sm">
          Zip Code : {row?.data?.loginRegionDetails?.zipCode}
        </p>
        <p className="text-sm">
          Time Zones :{" "}
          {JSON.stringify(row?.data?.loginRegionDetails?.timeZones)}
        </p>
        <p className="text-sm">
          Time Zone : {JSON.stringify(row?.data?.loginRegionDetails?.timeZone)}
        </p>
        {/* {Object.entries(row?.data?.loginRegionDetails || {}).map(
            ([key, value]) => (
              <div
                key={key}
                className="grid grid-cols-1 lg:grid-cols-2 gap-5 text-sm"
              >
                {key} : {JSON.stringify(value)}
              </div>
            )
          )} */}
      </div>
    );
  };

  const activityLogsTableColumns = [
    {
      name: "Corporate ID",
      selector: (row) => row?.corpId,
      width: "300px",
      sortable: true,
    },
    {
      name: "Agent Name",
      selector: (row) => row?.agentName,
      width: "300px",
    },
    {
      name: "Login Time",
      selector: (row) =>
        row?.loginTime ? isoTimestampToLocal(row.loginTime) : "N/A",
    },
  ];

  useEffect(() => {
    apiGetActivityLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full space-y-5">
      <SeoTags title="Activity Logs ‣ WaBM" />
      <div className="my-1 flex-1 space-y-3">
        <h1 className="text-2xl">Activity Logs</h1>
        <h3>Check Activity logs to monitor your team</h3>
      </div>
      <div className="wbm-card-3 space-y-3">
        <div className="rounded-md overflow-auto">
          <DataTable
            columns={activityLogsTableColumns.map((col) => ({
              ...col,
              cell: col?.cell
                ? (row, index, column, id) =>
                    col.cell(row, index, column, id, setExpandedRows)
                : col?.cell,
            }))}
            data={logsData}
            customStyles={activityLogTableStyles}
            pagination
            expandableRows
            expandableRowExpanded={(row) => expandedRows.includes(row?._id)}
            expandableRowsComponent={rowPreExpanded}
          />
        </div>
      </div>
    </main>
  );
};

export default ActivityLogs;

const activityLogTableStyles = {
  rows: {
    style: {},
  },
  headCells: {
    style: {
      backgroundColor: colorsConfig.mediumGrey,
      color: "#FFFFFF",
      fontSize: "0.9rem",
    },
  },
  cells: {
    style: {
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
};
